import React from "react";
import housingIcon from "../../PicesForPages/equal-housing-opportunity-logo-100-w.png";
import whatappIcon from "../../PicesForPages/WhatsappIcon.png";
import Logo from "../../PicesForPages/logo_white_the_mortgagist.png";
import { Link } from "react-router-dom";
// import ElevenLabsTTS from "../AI/ai";

function Footer() {
  // Scroll to the top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll
    });
  };
  return (
    <div className="footerParent">
      <div className="footerBox">
        <div className="footerTop">
          <div className="footerTopDiv footerTopDiv01 footerTopDiv001">
            <Link to="/" onClick={scrollToTop}>
              {" "}
              <img
                fetchPriority="high"
                loading="eager"
                src={Logo}
                alt="Logo"
                className="footerLogo"
              />
            </Link>
            {/* <span className="footerTopDivHeading">About Us</span>
            <span className="footerTopDivContent footerTopDivContent00">
              Our mission is to offer superior service that helps you achieve
              your targets. We deeply appreciate your trust and support. From
              the first call to the final closure, our team is with you every
              step of the way!
            </span> */}
          </div>
          {/* <iframe
            title="The Mortgageist Inc Office Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3052.3351886554033!2d-75.3815754!3d40.0902391!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c695c98235120b%3A0xd79eff078b4cdb24!2s150%20Allendale%20Rd%20Unit%202200%2C%20King%20of%20Prussia%2C%20PA%2019406%2C%20USA!5e0!3m2!1sen!2sin!4v1746712641605!5m2!1sen!2sin"
            width="200"
            height="250"
            style={{ border: 0, borderRadius: "0.1cm" }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            className="footerMap"
          ></iframe> */}
          <div className="footerTopDiv footerTopDiv01">
            <span className="footerTopDiv footerTopDiv00 ">
              <span className="footerTopDivHeading">Contact Us</span>
              <span className="footerTopDivContent footerTopDivContent00">
                <a
                  // href="https://maps.app.goo.gl/1Poe8xgBoiF3GDLX6"
                  href="https://maps.app.goo.gl/G5PhAHozSeMPGfhaA"
                  target="_blank"
                  rel="noreferrer"
                  className="footerTopDivContentIcon"
                >
                  <i className="ri-map-pin-line"></i>{" "}
                  <span>
                    134 John Robert Thomas Dr, <br />
                    2nd Floor, Exton, PA 19341
                  </span>
                </a>
                <a
                  href="tel:+1-610-618-0618"
                  className="aTag_Tel footerTopDivContentIcon"
                >
                  <i className="ri-phone-fill"></i> <span>(610) 618-0618</span>
                </a>
                <a
                  href="mailto: Contact@TheMortgageist.com"
                  className="aTag_Mail footerTopDivContentIcon"
                >
                  <i className="ri-mail-send-fill"></i>{" "}
                  <span>Contact@TheMortgageist.com</span>
                </a>
              </span>
            </span>
          </div>{" "}
          {/* <iframe
            title="The Mortgageist Inc Office Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3052.3351886554033!2d-75.3815754!3d40.0902391!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c695c98235120b%3A0xd79eff078b4cdb24!2s150%20Allendale%20Rd%20Unit%202200%2C%20King%20of%20Prussia%2C%20PA%2019406%2C%20USA!5e0!3m2!1sen!2sin!4v1746712641605!5m2!1sen!2sin"
            width="150"
            height="250"
            style={{ border: 0, borderRadius: "0.1cm" }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            className="footerMap"
          ></iframe> */}
          {/* <div className="footerTopDiv">
            <span className="footerTopDivHeading">Loan Options</span>
            <span className="footerTopDivContent footerTopDivContent00">
              <Link
                to="/which-loan-is-right-for-me"
                className="LoanOption LoanOption01"
                onClick={scrollToTop}
              >
                Fixed Rate Mortgage
              </Link>
              <Link
                to="/fha"
                className="LoanOption LoanOption02"
                onClick={scrollToTop}
              >
                FHA Home Loan
              </Link>
              <Link
                to="/va-loans"
                className="LoanOption LoanOption03"
                onClick={scrollToTop}
              >
                VA Home Loan
              </Link>
              <Link
                to="/which-loan-is-right-for-me"
                className="LoanOption LoanOption04"
                onClick={scrollToTop}
              >
                Jumbo Home Loan
              </Link>
              <Link
                to="/which-loan-is-right-for-me"
                className="LoanOption LoanOption05"
                onClick={scrollToTop}
              >
                First Time Home Buyer
              </Link>
              <Link
                to="/which-loan-is-right-for-me"
                className="LoanOption LoanOption06"
                onClick={scrollToTop}
              >
                Investment Property Loans
              </Link>
              <Link
                to="/refinancing"
                className="LoanOption LoanOption07"
                onClick={scrollToTop}
              >
                Refinance
              </Link>
            </span>
          </div>  */}
          <div className="footerTopDiv">
            <span className="footerTopDivHeading">Resources</span>
            <span className="footerTopDivContent footerTopDivContent00">
              {/* <Link
                to="/contact-us"
                className="Resource Resource01"
                onClick={scrollToTop}
              >
                Contact Us
              </Link> */}

              {/* <Link
                to="https://thmortgageist.my1003app.com/2692605/register/"
                target="_blank"
                rel="noreferrer"
                className="Resource Resource04"
              >
                Apply Online
              </Link>
              <Link
                to="/testimonials"
                className="Resource Resource05"
                onClick={scrollToTop}
              >
                Reviews
              </Link> */}

              <Link
                to="/ada-accessibility-statement"
                className="Resource Resource07"
                onClick={scrollToTop}
              >
                ADA Accessibility Statement
              </Link>
              <Link
                to="/privacy-policy"
                className="Resource Resource03"
                onClick={scrollToTop}
              >
                Privacy Policy
              </Link>
              {/* <Link
                to="/communication-policy"
                className="Resource Resource03"
                onClick={scrollToTop}
              >
                Communication Policy
              </Link> */}
              <Link
                to="quick-quote"
                className="Resource Resource02"
                onClick={scrollToTop}
              >
                Get A Quote
              </Link>
            </span>
          </div>
          <span className="footerTopDiv footerTopDiv00">
            <span className="footerTopDivHeading">Connect With Us</span>
            <span className="footerTopDivContent footerTopDivContentSM">
              <a
                href="https://www.facebook.com/TheMortgageist/"
                className="footerTopDivContentIcon"
                target="_blank"
                rel="noreferrer"
              >
                <i className="ri-facebook-box-fill"></i>{" "}
              </a>

              <a
                href="http://www.instagram.com/themortgageist"
                className="footerTopDivContentIcon"
                target="_blank"
                rel="noreferrer"
              >
                <i className="ri-instagram-fill"></i>
              </a>
              <a
                href="http://www.linkedin.com/company/themortgageist"
                className="footerTopDivContentIcon"
                target="_blank"
                rel="noreferrer"
              >
                <i className="ri-linkedin-box-fill"></i>
              </a>
              <a
                href="http://www.tiktok.com/@themortgageist"
                className="footerTopDivContentIcon"
                target="_blank"
                rel="noreferrer"
              >
                <i className="ri-tiktok-fill"></i>
              </a>
              <a
                href="http://www.youtube.com/@TheMortgageist"
                className="footerTopDivContentIcon"
                target="_blank"
                rel="noreferrer"
              >
                <i className="ri-youtube-fill"></i>
              </a>
            </span>
          </span>
        </div>
        <div className="footerMiddle">
          <img
            fetchPriority="high"
            loading="eager"
            src={housingIcon}
            alt="houseIcon"
            className="houseIcon"
          />
          <b>Equal Housing Opportunity </b>
          <br />
          <b> The Mortgageist Inc </b> | <b>Company NMLS: 2710734</b> |{" "}
          <b>
            <Link
              to="https://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/2710734"
              target="_blank"
              rel="noreferrer"
              className="Resource Resource06"
            >
              NMLS Consumer Access
            </Link>
          </b>
        </div>
        <div className="footerBottom">
          <span>Licensed in DE, FL, GA, KS, NJ, PA, TX & VA.</span>
          <span className="footerBottomDown">
            <b>
              Powered by{" "}
              <a
                href="https://staiminds.com/"
                className="shushankTechLink"
                target="_blank"
                rel="noreferrer"
              >
                ST AI Minds
              </a>
            </b>
            <span className="footerBottomDown02">
              This site is protected by{" "}
              <a
                href="https://staiminds.com/"
                className="shushankTechLink"
                target="_blank"
                rel="noreferrer"
              >
                ST AI Minds
              </a>{" "}
              <b>Privacy Policy</b> and <b>Terms of Service</b> apply.
            </span>
          </span>
        </div>
        <a
          href="https://www.linkedin.com/in/pandugayala-raja-naresh-b15b4986/"
          className="Developer"
          target="_blank"
          rel="noreferrer"
        >
          Crafted by: Pandugayala Raja Naresh | Web Developer
        </a>
        {/* <div className="goTop" onClick={scrollToTop}>
          <span>TOP</span>
          <ElevenLabsTTS />
        </div> */}
        <div className="WhatApp">
          <a
            href="https://wa.link/owcj43"
            // href="https://web.whatsapp.com/send/?phone=16106180618"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              fetchPriority="high"
              loading="eager"
              src={whatappIcon}
              alt="whatappIcon"
              className="whatappIcon"
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;
